module.exports = "/desktop-app/assets/img/driver_default_avt.png?90f2a87fc1679fd75bf541f7459a961a";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/icons/chat/driver_default_avt.png
// module id = vegI
// module chunks = 1